import { render, staticRenderFns } from "./SiteOrchestrator.vue?vue&type=template&id=8a522076&scoped=true&"
import script from "./SiteOrchestrator.vue?vue&type=script&lang=ts&"
export * from "./SiteOrchestrator.vue?vue&type=script&lang=ts&"
import style0 from "./SiteOrchestrator.vue?vue&type=style&index=0&id=8a522076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a522076",
  null
  
)

export default component.exports